// extracted by mini-css-extract-plugin
export default {"genericCard":"Qn-z","inline":"Rn-z","mastercard":"Sn-z","discover":"Tn-z","visa":"Un-z","amex":"Vn-z","active":"Wn-z"};